import { FC } from 'react';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
import styled from 'styled-components';

import { routes } from '~src/routingConfig';

const EmptyRowWrapper = styled.div`
  width: 100%;
  padding: 5px 15px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: ${({ theme }) => theme.baseBlue.a6};
`;

const StyledLink = styled(Link)`
  margin-left: 15px;
  color: ${({ theme }) => theme.baseBlue.a6};
  font-weight: 600;
  text-decoration: underline;
  &:hover {
    opacity: 1;
    text-decoration: underline;
  }
`;

interface Props {
  t: i18next.TFunction;
}

const EmptyRow: FC<Props> = ({ t }) => (
  <EmptyRowWrapper>
    <span data-translation="x.compare.table.row.empty.text">{t('x.compare.table.row.empty')}</span>
    <StyledLink to={routes.company.attributes}>{t('x.compare.table.row.empty.link')}</StyledLink>
  </EmptyRowWrapper>
);

export default EmptyRow;
